import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTraininline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("rect", {
				strokeLinecap: "square",
				x: 12,
				y: 5,
				width: 40,
				height: 40,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("path", { d: "M14 50h36m-38.953 5H53" }),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 21,
				cy: 33,
				r: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				strokeLinecap: "square",
				cx: 42.814,
				cy: 33,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M47.5 45L55 59M16.5 45L9 59" }),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				d: "M18 14h28v10H18z"
			})
		]
	})
});
export default SvgTraininline;
